import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import "./CouponModelStyle.css";

const CouponModel = ({ couponValue, setCouponModel, handleVerifyCoupon }) => {
  const [couponInput, setCouponInput] = useState(couponValue);

  return (
    <div className="coupon-model-wrapper">
      <div className="coupon-model-container">
        <div className="coupon-model-head ">
          <h3>Apply Coupon</h3>
          <button onClick={() => setCouponModel(false)}>
            <AiOutlineClose className="coupon-model-close" />
          </button>
        </div>
        <div className="coupon-model-body">
          <div className="signup-field">
            <label htmlFor="coupon">Enter Coupon</label>
            <input
              type="text"
              id="couponInput"
              placeholder="Enter Coupon(case sensitive)"
              required
              onChange={(e) => setCouponInput(e.target.value)}
            />
          </div>
        </div>
        <div className="coupon-submit-btn">
          <button
            onClick={() => {
              setCouponModel(false);
              handleVerifyCoupon(couponInput);
            }}
          >
            Verify Coupon
          </button>
        </div>
      </div>
    </div>
  );
};
export { CouponModel };
